module.exports = __webpack_public_path__ + "f466a821e30d073ebf222f8abfef1f7a.png";